<template>
    <div class="modal fade" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel" aria-hidden="true" id="series-modal">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" v-if="!series_id">シリーズ追加</h5>
                    <h5 class="modal-title" v-else>シリーズ編集</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <div class="form-group">
                        <label>シリーズ名</label>
                        <input type="text" ref="seriesName" class="form-control form-control-lg" v-model="series.series_name" placeholder="例）現代文学" @keydown.ctrl.enter="save()" />
                        <div class="text-muted small">
                            シリーズ名として読者に表示される名称です。
                        </div>
                    </div>
                    <div class="form-group">
                        <button class="btn btn-outline-primary"
                            :class="{active: series.is_group}"
                            @click="series.is_group = !series.is_group">
                            <i class="fas fa-check-circle" v-if="series.is_group"></i>
                            <i class="far fa-circle" v-else></i>
                            作品を束ねる
                        </button>
                        <div class="text-muted small">
                            作品リストに代表作品のみを表示します。
                            代表作品を選ぶと、シリーズページに遷移します。
                        </div>
                    </div>
                    <div class="form-group">
                        <label>説明</label>
                        <div class="text-pane">
                            <div class="text-pane-dummy">{{series.description + '\u200b'}}</div>
                            <textarea class="text-pane-editor"
                                v-model="series.description"
                                @keydown.ctrl.enter="save()"></textarea>
                        </div>
                        <div class="text-muted small">
                            シリーズの説明文です。<br>
                            シリーズページの上部に表示されます。
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" data-dismiss="modal">閉じる</button>
                    <button type="button" class="btn btn-outline-primary" @click="save()">保存 (ctrl + Enter)</button>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

.text-pane {
    position: relative;
    letter-spacing: 1px;
    border: 0px;
    border-radius: 4px;
    margin: 0 auto .5rem;
    .text-pane-dummy {
        overflow: hidden;
        font-size: 1rem;
        line-height: 2rem;
        box-sizing: border-box;
        padding: .5rem 1rem;
        min-height: 120px;
        white-space: pre-wrap;
        word-wrap: break-word;
        overflow-wrap: break-word;
        letter-spacing: 1px;
        border: 0;
        border-radius: 4px;
        opacity: 0;
    }
    .text-pane-editor {
        position: absolute;
        top: 0;
        left: 0;
        font-size: 1rem;
        line-height: 2rem;
        letter-spacing: 1px;
        display: block;
        overflow: hidden;
        box-sizing: border-box;
        padding: .5rem 1rem;
        width: 100%;
        height: 100%;
        border: 0;
        resize: none;
        &:focus {
            outline: none;
        }
        border-radius: 4px;
    }
}
</style>

<script>
export default {
    props: {
        series_id: {
            default: null,
        },
    },
    data() {
        return {
            series: {
                is_group: 0
            },
        }
    },
    methods: {
        load() {
            if (! this.series_id) {
                this.series = {
                    is_group: 0
                };
                return
            };
            axios.get("/mypage/series/edit", {params: {id: this.series_id}}).then(res => {
                this.series = res.data;
            }).catch(err => {
                alert.err(err.response);
            });
        },
        save() {
            axios.post("/mypage/series/save", this.series).then(res => {
                alert.msg(res.data);
                this.$emit("saved");
                this.series = {};
                $("#series-modal").modal("hide");
            }).catch(err => {
                alert.err(err.response);
            });
        }
    },
    mounted() {
        $("#series-modal").on("show.bs.modal", (e) => {
            this.load();
        });
        $("#series-modal").on("shown.bs.modal", (e) => {
            this.$refs.seriesName.focus();
        });
        $("#series-modal").on("hide.bs.modal", (e) => {
            this.$emit("closed");
        });
    }
}
</script>

